/* KWR combideals: gedeelde helpers (toevoegen aan winkelwagen, cart drawer verversen, dropdown in de winkelwagenmelding) */
(function () {
  if (window.kwrCd) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    return '€ ' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1];
  }

  function openCart() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (e) {}
    }
    window.location.href = root + 'cart';
  }

  function add(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (e) {
            throw new Error(e.description || e.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.');
          });
        }
        return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        try {
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: cart, sourceId: 'kwr-combideal', data: { source: 'kwr-combideal', itemCount: cart.item_count } };
          document.dispatchEvent(ev);
        } catch (e) {}
        openCart();
        return cart;
      });
  }

  window.kwrCd = { add: add, money: money, openCart: openCart };

  /* Dropdown in de winkelwagenmelding (de drawer wordt steeds opnieuw opgebouwd, daarom via document) */
  function closeNudgeDd() {
    document.querySelectorAll('.kwr-cdn .kwr-dd.is-open').forEach(function (dd) {
      dd.classList.remove('is-open');
      dd.querySelector('.kwr-dd__trigger').setAttribute('aria-expanded', 'false');
      dd.querySelector('.kwr-dd__panel').hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var tr = e.target.closest('.kwr-cdn .kwr-dd__trigger');
    if (tr) {
      var dd = tr.closest('.kwr-dd'), was = dd.classList.contains('is-open');
      closeNudgeDd();
      if (!was) { dd.classList.add('is-open'); tr.setAttribute('aria-expanded', 'true'); dd.querySelector('.kwr-dd__panel').hidden = false; }
      return;
    }
    var op = e.target.closest('.kwr-cdn .kwr-dd__option');
    if (op) {
      var box = op.closest('.kwr-dd');
      box.setAttribute('data-value', op.getAttribute('data-vid'));
      box.querySelector('.kwr-dd__value').textContent = op.textContent;
      box.querySelectorAll('.kwr-dd__option').forEach(function (o) { var a = o === op; o.classList.toggle('is-active', a); o.setAttribute('aria-selected', a); });
      closeNudgeDd();
      return;
    }
    if (!e.target.closest('.kwr-cdn .kwr-dd')) closeNudgeDd();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNudgeDd(); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kwr-cd-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var item = btn.closest('[data-kwr-cd-item]');
    var dd = item ? item.querySelector('[data-kwr-cd-dd]') : null;
    var select = item ? item.querySelector('select[data-kwr-cd-variant]') : null;
    var msg = item ? item.querySelector('[data-kwr-cd-msg]') : null;
    var id = Number(dd ? dd.getAttribute('data-value') : (select ? select.value : btn.getAttribute('data-variant')));
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.disabled = true;
    btn.textContent = 'Bezig...';
    if (msg) msg.textContent = '';
    add([{ id: id, quantity: 1 }])
      .then(function () {
        btn.textContent = 'Toegevoegd';
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2500);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        if (msg) msg.textContent = err.message;
      });
  });
})();